import { GridBaseDataProvider } from '../../../../../grid/GridBaseDataProvider';
import { Column, ColumnKeys, CredentialsManagerReadResponse, DataGridItem, DataGridItemsResponse } from '../types';
import { ColumnDetails, GetRowsRequest, GetSummaryResponse } from '../../../../../grid/types/common';
import { translateFn } from '../../../../../utils/translator.helper';
import { ConsoleRequest, DataProviderType } from '../../../../../utils/request';

export class CredentialsManagerGridTableDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private cachedGetResponse?: CredentialsManagerReadResponse;
  private readonly allColumnDetails: {};

  constructor(public dependencies: any, allColumnDetails: ColumnDetails<Column, ColumnKeys>[]) {
    super();
    this.allColumnDetails = allColumnDetails.reduce((acc, curr) => ({ ...acc, [curr.key]: curr }), {});
  }

  public async readRecords(request: GetRowsRequest<Column, ColumnKeys>): Promise<CredentialsManagerReadResponse> {
    const payload = ConsoleRequest.mapGridRequestToPayload(request, this.dependencies.getTimezone());
    return ConsoleRequest.createRequest<CredentialsManagerReadResponse>({
      dataProviderType: DataProviderType.CORE,
      payload: payload,
      endpoint: 'Credentials',
      method: 'readRecords',
    });
  }

  async getSummary(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetSummaryResponse> {
    this.cachedGetResponse = await this.readRecords(request);
    return {
      summary: '',
      numItems: this.cachedGetResponse.total,
    };
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<DataGridItemsResponse> {
    if (!this.cachedGetResponse) {
      this.cachedGetResponse = await this.readRecords(request);
    }
    const items = this.cachedGetResponse.data.map(item => {
      if (item.isPem) {
        return {
          ...item,
          password: translateFn('PEM Certificate'),
          actions: '*',
        } as DataGridItem;
      }
      return { ...item, actions: '*' } as DataGridItem;
    });

    return { rawEvents: items, success: true };
  }
}
